import { Breadcrumbs, Link, Typography } from '@mui/material';

type FileStoragePathSegment = {
  id?: string;
  name: string;
};

type FileStoragePathHeaderProps = {
  rootLabel: string;
  segments: FileStoragePathSegment[];
  onRootClick?: () => void;
  onSegmentClick?: (segmentIndex: number) => void;
};

export const FileStoragePathHeader = ({
  rootLabel,
  segments,
  onRootClick,
  onSegmentClick,
}: FileStoragePathHeaderProps) => {
  const itemSx = {
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
    maxWidth: { xs: 140, sm: 220, md: 280 },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  return (
    <Breadcrumbs
      aria-label="file storage breadcrumbs"
      separator=">"
      sx={{
        mb: 1.5,
        overflow: 'hidden',
        '& .MuiBreadcrumbs-ol': {
          flexWrap: 'nowrap',
          overflow: 'hidden',
          alignItems: 'center',
        },
        '& .MuiBreadcrumbs-li': {
          display: 'inline-flex',
          alignItems: 'center',
        },
        '& .MuiBreadcrumbs-separator': {
          display: 'inline-flex',
          alignItems: 'center',
          lineHeight: 1.2,
          mx: 0.75,
        },
      }}
    >
      {segments.length ? (
        <Link
          component="button"
          underline="hover"
          color="inherit"
          variant="body2"
          sx={itemSx}
          onClick={onRootClick}
        >
          {rootLabel}
        </Link>
      ) : (
        <Typography variant="body2" color="text.primary" fontWeight={500} sx={itemSx}>
          {rootLabel}
        </Typography>
      )}

      {segments.map((segment, index) => {
        const isLast = index === segments.length - 1;
        if (isLast) {
          return (
            <Typography
              key={segment.id || `${segment.name}-${index}`}
              variant="body2"
              color="text.primary"
              fontWeight={500}
              sx={itemSx}
            >
              {segment.name}
            </Typography>
          );
        }

        return (
          <Link
            key={segment.id || `${segment.name}-${index}`}
            component="button"
            underline="hover"
            color="inherit"
            variant="body2"
            sx={itemSx}
            onClick={() => onSegmentClick?.(index)}
          >
            {segment.name}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};
